import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.roles;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//get all roles
const getRoles = async () => {
    let response;
    await axios.get(baseUrl.getAll, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log("res: ", res)
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getRole = async (role) => {
    let response;
    await axios.get(baseUrl.getRole + "show/" + role, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const createRole = async (role) => {
    let response;
    await axios.post(baseUrl.create, role, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const deleteRole = async (id) => {
    let response;
    await axios.delete(baseUrl.delete + id, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const assignPermission = async (role) => {
    let response;
    await axios.get(baseUrl.getRole + "show/" + role, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const unAssignPermission = async (role) => {
    let response;
    await axios.get(baseUrl.getRole + "show/" + role, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}


export default {
    getRoles, getRole, createRole, deleteRole, assignPermission, unAssignPermission,

}
